import { answerCall as answerCallSdk } from '../../../../services/cxone-sdk.service';
import { logger } from '../../../../utils/logger';
import { CXoneEventsSubscriptionContext } from '../../subscription-context';

export function markAgentLegActiveWhenCallReady(ctx: CXoneEventsSubscriptionContext): void {
  const currentCallState = ctx.callStateRef.current;
  if (
    (currentCallState.status === 'active' || currentCallState.status === 'holding') &&
    currentCallState.contactId
  ) {
    ctx.setIsAgentLegActive(true);
  }
}

export function handleAutoAcceptCall(ctx: CXoneEventsSubscriptionContext): void {
  const currentCallState = ctx.callStateRef.current;
  if (
    !currentCallState.isAutoAccept ||
    currentCallState.status === 'active' ||
    !currentCallState.contactId
  ) {
    return;
  }

  logger.debug('[Events] WebRTC connected for auto-accept call, calling acceptContact API...');

  answerCallSdk(currentCallState.contactId)
    .then(() => {
      logger.debug('[Events] Auto-accept: acceptContact API call succeeded');
    })
    .catch((error: unknown) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const httpStatus = (error as any)?.data?.status || (error as any)?.status;
      const errMsg = error instanceof Error ? error.message : String(error);
      if (httpStatus === 409 || errMsg.includes('409')) {
        logger.debug('[Events] Auto-accept: Call already accepted (409), continuing...');
      } else {
        logger.error('[Events] Auto-accept: acceptContact API call failed:', error);
      }
    });

  ctx.setIsRinging(false);
  ctx.setCallState((prev) => ({
    ...prev,
    status: 'active',
    startTime: prev.startTime || new Date(),
  }));
  ctx.setIsAgentLegActive(true);
}

export function attachRemoteAudioStream(
  ctx: CXoneEventsSubscriptionContext,
  remoteStream: MediaStream | undefined
): void {
  const audioElement = ctx.audioRef?.current;
  if (!audioElement || !remoteStream) {
    return;
  }

  if (!audioElement.srcObject) {
    audioElement.srcObject = remoteStream;
  } else if ((audioElement.srcObject as MediaStream).id !== remoteStream.id) {
    audioElement.srcObject = remoteStream;
  }

  if (audioElement.muted) {
    audioElement.muted = false;
  }
  if (audioElement.volume < 1.0) {
    audioElement.volume = 1.0;
  }

  if (audioElement.paused) {
    audioElement.play().catch((err) => {
      logger.warn('[Events] Audio play() failed:', err.message);
    });
  }

  markAgentLegActiveWhenCallReady(ctx);
}
